import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import type { Topic } from "~/lqs";
import { usePlayerActions } from "../actions";
import { useAreTopicTagsShowing } from "../tags";

export function TagsControl({
  topic,
  label = "Topic tags",
  size,
}: {
  topic: Topic;
  label?: string;
  size?: "small" | "medium";
}) {
  const areTopicTagsShowing = useAreTopicTagsShowing(topic.id);

  const playerActions = usePlayerActions();

  function handleToggleTags() {
    playerActions.toggleTopicTags(topic);
  }

  return (
    <FormControlLabel
      sx={{ justifyContent: "space-between", marginInline: 0 }}
      control={
        <Switch
          checked={areTopicTagsShowing}
          onChange={handleToggleTags}
          size={size}
        />
      }
      label={label}
      labelPlacement="start"
      slotProps={{
        typography: {
          variant: size === "small" ? "body2" : undefined,
        },
      }}
    />
  );
}
